import { useQuery } from "@tanstack/react-query";
import { Card } from "../../../components/Card";
import { AnalyticsCard } from "../../dashboard/components/SessionChart";
import { Rating } from "../../praxis-call/components/Rating";
import { LockWithTooltip } from "./LockWithTooltip";
import { api } from "../../../services/api";

export function BadgeCenterActivity({ isLocked, totalXPPoints }: { isLocked: boolean, totalXPPoints: number }) {

    const {
        data: sessionCountsData,
        isLoading: isLoadingSessionCounts,
        refetch: refetchSessionCounts,
    } = useQuery({
        queryKey: ["session-counts"],
        queryFn: () => api.sessionCounts(),
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });

    const {
        data: praxisScores,
        isLoading: isLoadingPraxisScores,
        refetch: refetchPraxisScores,
    } = useQuery({
        queryKey: ["praxis-scores"],
        queryFn: () => api.getPraxisScores(),
        refetchOnWindowFocus: false,
    });

    const scores = praxisScores?.data || {};
    const sessionCounts = sessionCountsData?.data || {};

    return (
        <Card className="!p-[18px]">
            <div className="flex flex-col gap-2">

                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1.5">
                        {isLocked ? <LockWithTooltip /> : <></>}
                        <div className="text-base font-semibold text-black">PraxisPlay Activity</div>
                    </div>
                </div>

                <div className="items-center gap-2 flex w-full">
                    <AnalyticsCard title="This Week" value={sessionCounts?.thisWeekSessions || "--"} />
                    <AnalyticsCard title="Last Week" value={sessionCounts?.lastWeekSessions || "--"} />
                    <AnalyticsCard title="Last Month" value={sessionCounts?.lastMonthSessions || "--"} />
                    <AnalyticsCard title="Total Sessions" value={sessionCounts?.allSessions || "--"} />
                </div>
                <div className="bg-gray-301 p-3 rounded-[6px] flex items-center justify-between">
                    <span className="text-black text-sm ">XP</span>
                    <div className="flex items-center gap-2.5">
                        <span>{totalXPPoints || "--"}</span>
                    </div>
                </div>
                <div className="bg-gray-301 p-3 rounded-[6px] flex items-center justify-between">
                    <span className="text-black text-sm ">Avg. Praxis Score</span>
                    <div className="flex items-center gap-2.5">
                        <Rating value={scores?.averagePraxisScore || 0} showMax={false} showCount={false} showRemainingStars={true} />
                        <span>{scores?.averagePraxisScore || "--"}</span>
                    </div>
                </div>
                <div className="bg-gray-301 p-3 rounded-[6px] flex items-center justify-between">
                    <span className="text-black text-sm ">Last Praxis Score</span>
                    <div className="flex items-center gap-2.5">
                        <Rating value={scores?.lastPraxisScore || 0} showMax={false} showCount={false} showRemainingStars={true} />
                        <span>{scores?.lastPraxisScore || "--"}</span>
                    </div>
                </div>
            </div>
        </Card>
    )
}